var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-divider"},[_c('el-divider',{attrs:{"content-position":"center"}},[_c('span',[_vm._v(_vm._s(_vm.text))]),(_vm.status)?_c('span',[_vm._v(_vm._s(_vm.status))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }